import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["disabled"]

import { ref, computed, toRef } from 'vue'
    import type { NoteLoggerViewModel } from '@Alternatives/Alternatives/Components/NoteLogger'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NoteLogger',
  props: {
    viewModel: {}
  },
  emits: ["create-note"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    const vm = toRef(props, 'viewModel')

    const note = ref<string | null>(null)

    const opened = computed(() => vm.value?.opened ?? false)

    // ---------------- actions ----------------

    function create()
    {
        emit('create-note', note.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Log a note", -1 /* CACHED */)),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((note).value = $event)),
                    class: "form-control",
                    rows: "5",
                    placeholder: "Enter text here..."
                  }, null, 512 /* NEED_PATCH */), [
                    [
                      _vModelText,
                      note.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: create,
                  disabled: !note.value,
                  type: "button",
                  class: "btn btn-primary"
                }, "Create", 8 /* PROPS */, _hoisted_8)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})